var React = require('react');

function SearchIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M10.0436 6.06152C10.0436 8.6677 8.05419 10.6536 5.75258 10.6536C3.45097 10.6536 1.46158 8.6677 1.46158 6.06152C1.46158 3.45534 3.45097 1.46939 5.75258 1.46939C8.05419 1.46939 10.0436 3.45534 10.0436 6.06152ZM9.53697 10.5784C8.5284 11.5154 7.20357 12.084 5.75258 12.084C2.59278 12.084 0.03125 9.38763 0.03125 6.06152C0.03125 2.73541 2.59278 0.0390625 5.75258 0.0390625C8.91239 0.0390625 11.4739 2.73541 11.4739 6.06152C11.4739 7.33335 11.0994 8.51311 10.4601 9.48524L14.7961 13.5437C15.0843 13.8136 15.1113 14.277 14.8564 14.5788C14.6015 14.8807 14.1611 14.9066 13.8728 14.6368L9.53697 10.5784Z","fill":"#636363"}));
}

SearchIcon.defaultProps = {"width":"16","height":"15","viewBox":"0 0 16 15","fill":"none"};

module.exports = SearchIcon;

SearchIcon.default = SearchIcon;
